import API from "../config/api.js";

export const CalendarService = {

    getUserTasksList() {
      return API.get(`api/calendar/task-list`);
    },
    getTasksByAssignee(id){
      return API.get(`api/calendar/user/${id}/task-list`);
    }

  
};